import Vue from 'vue'
import { findIndex } from 'lodash'
import queriesApi from '@/api/queries'
import executeQueryApi from '@/api/executeQuery'

export const SET_QUERIES = 'SET_QUERIES'
export const SET_SELECTED_QUERY = 'SET_SELECTED_QUERY'
export const SET_SELECTED_DATABASE = 'SET_SELECTED_DATABASE'
export const SET_NEW_QUERY_IN_DATABASE = 'SET_NEW_QUERY_IN_DATABASE'
export const DELETE_QUERY = 'DELETE_QUERY'
export const UPDATE_QUERY = 'UPDATE_QUERY'
export const SET_RESULT_QUERY = 'SET_RESULT_QUERY'
export const CLEAN_RESULT_QUERY = 'CLEAN_RESULT_QUERY'
export const CLEAR_QUERIES = 'CLEAR_QUERIES'

const state = {
  queries: [],
  selectedQuery: {},
  resultQuery: {
    isError: false,
    result: null
  }
}

const getters = {
  getterQueries: (state) => state.queries,
  getterSelectedQuery: (state) => state.selectedQuery,
  getterResultQuery: (state) => state.resultQuery
}

const mutations = {
  [SET_QUERIES] (state, value) {
    if (value) {
      state.queries = value
    } else {
      state.queries = []
    }
  },
  [SET_SELECTED_QUERY] (state, value) {
    if (value) {
      state.selectedQuery = value
    } else {
      state.selectedQuery = {}
    }
  },
  [SET_NEW_QUERY_IN_DATABASE] (state, value) {
    if (value) {
      const index = findIndex(state.queries, (database) => database.id === value.database.id)

      if (index > -1) {
        if (state.queries[index].queries) {
          state.queries[index].queries.push(value)
        } else {
          Vue.set(state.queries[index], 'queries', [value])
        }
      }
    }
  },
  [DELETE_QUERY] (state, value) {
    if (value) {
      state.queries.map((database, indexDatabase) => {
        database.queries.map((query, index) => {
          if (query.id === value) {
            state.queries[indexDatabase].queries.splice(index, 1)
          }
        })
      })
    }
  },
  [UPDATE_QUERY] (state, value) {
    if (value) {
      const indexDatabase = findIndex(state.queries, (database) => database.id === value.database.id)

      if (indexDatabase > -1) {
        const indexQuery = findIndex(state.queries[indexDatabase].queries, (query) => query.id === value.id)

        if (indexQuery > -1) {
          state.queries[indexDatabase].queries[indexQuery].valueFields = []
          state.queries[indexDatabase].queries[indexQuery].paramsSqlExplanation = value.paramsSqlExplanation
          state.queries[indexDatabase].queries[indexQuery].description = value.description
          state.queries[indexDatabase].queries[indexQuery].query = value.query
        } else {
          // Caso for banco diferente
          state.queries.map((database, indexDatabaseMap) => {
            database.queries.map((query, indexQueryMap) => {
              if (query.id === value.id) {
                state.queries[indexDatabaseMap].queries.splice(indexQueryMap, 1)
                state.queries[indexDatabase].queries.push(value)
              }
            })
          })
        }
      }
    }
  },
  [SET_RESULT_QUERY] (state, value) {
    if (value) {
      state.resultQuery = value
    }
  },
  [CLEAN_RESULT_QUERY] (state) {
    state.resultQuery = {
      isError: false,
      result: null
    }
  },
  [CLEAR_QUERIES] (state) {
    state.queries = []
    state.selectedQuery = {}
    state.resultQuery = {
      isError: false,
      result: null
    }
  }
}

const actions = {
  actionGetQueries ({ commit }) {
    return queriesApi.getQueries()
      .then((response) => {
        commit(SET_QUERIES, response.data.databases)
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionGetQuery ({ _ }, id) {
    return queriesApi.getQuery(id)
      .then((response) => {
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionSaveQuery ({ commit }, body) {
    return queriesApi.saveQuery(body)
      .then((response) => {
        commit(SET_NEW_QUERY_IN_DATABASE, response.data)
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionPutQuery ({ commit }, params) {
    return queriesApi.putQuery(params.id, params.body)
      .then((response) => {
        commit(UPDATE_QUERY, response.data)
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionDeleteQuery ({ commit }, id) {
    return queriesApi.deleteQuery(id)
      .then((response) => {
        commit(DELETE_QUERY, id)
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionExecuteQuery ({ commit }, body) {
    return executeQueryApi.executeQuery(body)
      .then((response) => {
        commit(SET_RESULT_QUERY, { result: response.data, isError: false })
        return Promise.resolve(response)
      })
      .catch((e) => {
        commit(SET_RESULT_QUERY, { result: e.response.data, isError: true })
        return Promise.reject(e.response.data)
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
